const getOptionFromList = (list, value, typeValue = 'id') => (
  list.find(option => option[typeValue] === value) || null
);

export default getOptionFromList;
